import {
  EXTERNAL_API_CREATE_EXTERNAL_API_BEGIN,
  EXTERNAL_API_CREATE_EXTERNAL_API_SUCCESS,
  EXTERNAL_API_CREATE_EXTERNAL_API_FAILURE,
  EXTERNAL_API_CREATE_EXTERNAL_API_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { getCookie, updateUserIpInCookie } from '../../../common/utils/api_utils';

export function createExternalApi(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: EXTERNAL_API_CREATE_EXTERNAL_API_BEGIN,
    });

    const { projectId, version } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const header = builderSurfaceJsonContentHeader(projectId, userIp);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/external-api/`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: EXTERNAL_API_CREATE_EXTERNAL_API_SUCCESS,
              data: res,
            });
            toast.success('Saved Successfully !', {});
            resolve(res);
          } else {
            dispatch({
              type: EXTERNAL_API_CREATE_EXTERNAL_API_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: EXTERNAL_API_CREATE_EXTERNAL_API_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCreateExternalApiError() {
  return {
    type: EXTERNAL_API_CREATE_EXTERNAL_API_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EXTERNAL_API_CREATE_EXTERNAL_API_BEGIN:
      return {
        ...state,
        createExternalApiPending: true,
        createExternalApiError: null,
      };

    case EXTERNAL_API_CREATE_EXTERNAL_API_SUCCESS:
      return {
        ...state,
        createExternalApiPending: false,
        createExternalApiError: null,
      };

    case EXTERNAL_API_CREATE_EXTERNAL_API_FAILURE:
      return {
        ...state,
        createExternalApiPending: false,
        createExternalApiError: action.data.error,
      };

    case EXTERNAL_API_CREATE_EXTERNAL_API_DISMISS_ERROR:
      return {
        ...state,
        createExternalApiError: null,
      };

    default:
      return state;
  }
}
